import Vue from 'vue';
import router from './router';

// Primary Navigation
import VaultsList from './pages/VaultsList';
import VaultDashboard from './pages/VaultDashboard';

// File and Tag
import ManageFiles from './pages/ManageFiles';
import Tagging from './pages/ManageFiles/Tagging';
import Upload from './pages/ManageFiles/Upload';
import RecentFiled from './pages/ManageFiles/RecentFiled';
import AddVault from './pages/AddVault';
import VaultMembers from './pages/VaultMembers';
import VaultSettings from './pages/VaultSettings';
import SearchDocuments from './pages/SearchDocuments';

// Members
import ManageInvitations from './pages/ManageInvitations';
import InviteMembers from './pages/ManageMembers/InviteMembers';
import InvitedMembers from './pages/ManageMembers/InvitedMembers';
import AddDeleteMembers from './pages/ManageMembers/AddDeleteMembers';
import RoleRestrictionsPerTag from './pages/ManageMembers/RoleRestrictionsPerTag';

// Billing and Account
import BillingAccount from './pages/BillingAccount';
import ChangePlan from './pages/BillingAccount/ChangePlan';
import UpdateBillingDetails from './pages/BillingAccount/UpdateBillingDetails';
import SubscriptionInvoices from './pages/BillingAccount/SubscriptionInvoices';
import Subscription from './pages/BillingAccount/SubscriptionInvoices/Subscription';
import Invoices from './pages/BillingAccount/SubscriptionInvoices/Invoices';


// User Profile
import ChangePassword from './pages/UserProfile/ChangePassword';
import PersonalDetails from './pages/UserProfile/PersonalDetails';

// Vault Details
import VaultDetails from './pages/VaultDetails';
import RequestTransfers from './pages/Ownership/RequestTransfers';

import TagsList from './pages/ManageTag/TagsList.vue';
import AcceptAllInvitation from './pages/Onboarding/AcceptAllInvitation.vue';

export default [{
        path: '/',
        redirect: '/vaults'
    },
    {
        path: '/invite/accept-all',
        component: AcceptAllInvitation,
        name: 'invite-accept-all',
        meta: { public: true }
    },
    {
        path: '/vaults',
        component: VaultsList,
        name: 'vaults',
    },
    {
        path: '/vault-dashboard/:vault_id?',
        component: VaultDashboard,
        name: 'dashboard',
        meta: {
            header: 'Dashboard'
        },
    },
    {
        path: '/vault-documents/:vault_id?/search',
        component: SearchDocuments,
        name: 'search-documents',
        meta: {
            header: 'Documents'
        }
    },
    {
        path: '/vaults/:vault_id?/manage/',
        component: ManageFiles,
        children: [{
                path: 'tagging',
                component: Tagging,
                name: 'tagging',
                meta: {
                    header: 'File and Tag'
                }
            },
            {
                path: 'upload',
                component: Upload,
                name: 'upload',
                meta: {
                    header: 'Upload'
                }
            },
            {
                path: 'recently-filed',
                component: RecentFiled,
                name: 'recently-filed',
                meta: {
                    header: 'Recently Filed'
                }
            },
        ]
    },
    {
        path: '/vault-settings/:vault_id?/',
        component: VaultSettings,
        children: [{
                path: 'manage-users/invitations/',
                component: ManageInvitations,
                children: [{
                        path: 'invite-members',
                        component: InviteMembers,
                        name: 'invite-members',
                        meta: {
                            header: 'Invite Members'
                        }
                    },
                    {
                        path: 'invited-members',
                        component: InvitedMembers,
                        name: 'invited-members',
                        meta: {
                            header: 'Invited Members'
                        }
                    }
                ]
            },
            {
                path: 'billing-account',
                component: BillingAccount,
                children: [{
                        path: 'change-plan',
                        component: ChangePlan,
                        name: 'change-plan',
                        meta: {
                            header: 'Change Plan'
                        }
                    },
                    {
                        path: 'update-billing-details',
                        component: UpdateBillingDetails,
                        name: 'update-billing-details',
                        meta: {
                            header: 'Update Billing Details'
                        }
                    },
                    {
                        path: 'subscription-and-invoices',
                        component: SubscriptionInvoices,
                        children: [{
                                path: 'subscription',
                                component: Subscription,
                                name: 'subscription',
                                meta: {
                                    header: 'Subscription Details'
                                }
                            },
                            {
                                path: 'invoices',
                                component: Invoices,
                                name: 'invoices',
                                meta: {
                                    header: 'Invoices'
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'manage-users/add-delete-members',
                component: AddDeleteMembers,
                name: 'add-delete-members',
                meta: {
                    header: 'Edit/Delete Members',
                }
            },
            {
                path: 'manage-users/role-restrictions-tag',
                component: RoleRestrictionsPerTag,
                name: 'role-restrictions-tag',
                meta: {
                    header: 'Role Restrictions per Tag',
                }
            },
            {
                path: 'vault-details',
                component: VaultDetails,
                name: 'vault-details',
                meta: {
                    header: 'Vault Details',
                }
            },
            {
                path: 'transfer-ownership',
                component: RequestTransfers,
                name: 'transfer-ownership',
                meta: {
                    header: 'Transfer Ownership',
                }
            },
            {
                path: 'manage-tags',
                component: TagsList,
                name: 'manage-tags',
                meta: {
                    header: 'Manage Tags',
                }
            },
        ]
    },
    {
        path: '/account-settings/user-profile/change-password',
        component: ChangePassword,
        name: 'change-password',
        meta: {
            header: 'Change Password',
        }
    },
    {
        path: '/account-settings/user-profile/personal-details',
        component: PersonalDetails,
        name: 'personal-details',
        meta: {
            header: 'Personal Details',
        }
    },
    {
        path: '/vault-members/:vault_id?/members-list',
        component: VaultMembers,
        name: 'vault-members',
        meta: {
            header: 'Members'
        }
    },
    {
        path: '/add-vault',
        component: AddVault,
        name: 'add-vault'
    }
];